module.exports = __webpack_public_path__ + "static/media/5.f4be6c8f.jpg";